export const LANGUAGE_SET = 'language_set';

export const ALERT_SHOW = 'alert_show';
export const ALERT_HIDE = 'alert_hide';
export const ALERT_LOCK = 'alert_lock';
export const ALERT_UNLOCK = 'alert_unlock';
